module.exports = __webpack_public_path__ + "static/media/fg.0718ac2e.png";